import React from 'react'
import styles from './dialogHeader.module.scss'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { Icon as QDSIcon, Text } from '@sendoutcards/quantum-design-ui'

type DialogHeaderProps = {
  onBack: () => void
  onClose?: () => void
}

const DialogHeader: React.FC<DialogHeaderProps> = props => {
  const { onBack, onClose } = props

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        position: 'sticky',
        margin: '1rem',
      }}
    >
      <div className={styles.backButton} onClick={onBack}>
        <QDSIcon
          name="leftChevron"
          size="xSmall"
          primaryColor="primaryBodyText"
        />
        <Text type="caption" weight="bold" content="Back" />
      </div>
      {onClose && (
        <button
          style={{
            border: 'none',
            outline: 'none',

            width: '34px',
            height: '34px',

            backgroundColor: '#F8F5F6',
            borderRadius: '6px',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            marginLeft: '0.5rem',
          }}
          onClick={onClose}
        >
          <Icon name="x" size={12} />
        </button>
      )}
    </div>
  )
}

export default DialogHeader
